// extracted by mini-css-extract-plugin
export default {"carouselItem":"_bcbebad1","carouselSnapItemStart":"_a27b669d","carouselSnapItemEnd":"_36716712"};